import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Users, Shield, Zap } from 'lucide-react';
import bg3 from '../assets/images/bg3.jpg';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            className="max-w-3xl mx-auto text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-heading text-4xl md:text-5xl font-bold mb-6">
              {t('about.title')}
            </h1>
            <p className="text-lg text-muted-foreground">
              {t('about.mission')}
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
            >
              <img 
                src={bg3}
                alt="Team"
                className="w-full aspect-[4/3] object-cover rounded-xl"
              />
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
            >
              <h2 className="font-heading text-3xl font-semibold mb-6">
                Notre Vision
              </h2>
              <p className="text-muted-foreground mb-4">
                {t('about.description')}
              </p>
              <p className="text-muted-foreground">
                Nous croyons que tout le monde devrait avoir accès aux meilleurs contenus de divertissement, 
                peu importe leur budget. C'est pourquoi nous avons créé izyko - une plateforme qui rend 
                l'accès à des platformes en ligne simple, sécurisé et abordable.
              </p>
            </motion.div>
          </div>

          {/* Values */}
          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: Users,
                title: "Communauté",
                description: "Nous construisons une communauté où chacun peut bénéficier des meilleurs services en ligne."
              },
              {
                icon: Shield,
                title: "Sécurité",
                description: "La sécurité de vos données et de vos paiements est notre priorité absolue."
              },
              {
                icon: Zap,
                title: "Simplicité",
                description: "Une expérience utilisateur intuitive pour un accès instantané à vos abonnements."
              }
            ].map((value, index) => (
              <motion.div
                key={index}
                className="bento-card text-center"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 + index * 0.1 }}
              >
                <div className="w-12 h-12 bg-primary/10 flex items-center justify-center mx-auto mb-6">
                  <value.icon className="h-6 w-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-xl font-semibold mb-3">
                  {value.title}
                </h3>
                <p className="text-muted-foreground">
                  {value.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
